import graphql__d0013dea7cae0520990c from "./__generated__/RecentOrganizationAppsMenuItemQuery.graphql.ts";
import graphql__8e9672df303c0009babf from "./__generated__/RecentOrganizationAppsMenuItem_viewer.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'
import { useNavigate } from 'react-router-dom'

import { RecentOrganizationAppsMenuItem_viewer$key } from './__generated__/RecentOrganizationAppsMenuItem_viewer.graphql'
import { RecentOrganizationAppsMenuItemQuery } from './__generated__/RecentOrganizationAppsMenuItemQuery.graphql'
import { RecentOrganizationAppsRefetchQuery } from './__generated__/RecentOrganizationAppsRefetchQuery.graphql'
import { AppTenantMenuHeading } from './AppTenantMenu'
import AppTenantMenuButton from './AppTenantMenuButton'

const query = graphql__d0013dea7cae0520990c

const refetchableOrganizations = graphql__8e9672df303c0009babf

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
}

// Menu item for accessing the organization apps that a user has access to.
export default function RecentOrganizationAppsMenuItem({ isOpen }: Props) {
  const { databasesText, isRenamed } = useAppToDatabaseRename()

  const { viewer } = useLazyLoadQuery<RecentOrganizationAppsMenuItemQuery>(
    query,
    {},
  )
  const [data, refetch] = useRefetchableFragment<
    RecentOrganizationAppsRefetchQuery,
    RecentOrganizationAppsMenuItem_viewer$key
  >(refetchableOrganizations, viewer)

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
  }, [refetch, isOpen])

  const navigate = useNavigate()

  const recentApps = data.me?.recentOrganizationApps || []
  if (!recentApps.length) {
    return <></>
  }

  return (
    <div className="flex flex-col gap-0.5 pt-3">
      <AppTenantMenuHeading heading={`Recently visited ${databasesText}`} />

      {recentApps.map((recentApp, index) => {
        const orgSlug = (recentApp.tenant as { slug: string }).slug || ''
        const orgName = (recentApp.tenant as { name: string }).name || ''

        const redirectTo = paths.app({
          organizationSlug: orgSlug,
          appSlug: recentApp.slug,
          isRenamed,
        })

        return (
          <AppTenantMenuButton
            key={index}
            label={orgName ? `${orgName} / ${recentApp.name}` : recentApp.name}
            onClick={() => navigate(redirectTo)}
          />
        )
      })}
    </div>
  )
}
